import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { classifyHighIntentInteraction, sendEvent, trackPageView } from './analytics';

export default function AnalyticsEvents() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location);
  }, [location]);

  useEffect(() => {
    const handleClick = (event) => {
      const element = event.target.closest('a, button');
      if (!element) return;

      const interaction = classifyHighIntentInteraction(element, window.location.pathname);
      if (interaction) sendEvent(interaction.name, interaction.params);
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return null;
}
